<template>
  <section class="content" style="width: 100%;">
  <div >
    <div class="form-row">
        <div class="form-group">
          <label>Title</label>
            <div class="form-select">
              <b-form-input @keyup="changeTittle()" style="height: 40px !important" v-bind:class="{ 'is-invalid': tittle_error }" v-model="tittle" type="text" placeholder="Tittle"/>
            </div>
            <div v-if="tittle_error">
              <p class="login-alert-msg error-content">* Enter the tittle</p>
            </div>
        </div>
        <div class="form-group">
          <input type="button" @click="submit()" style="float: right;" value="Save" class="submit" name="submit" id="submit" />
        </div>
    </div>
  </div>
    <!-- Default box -->
    <VueCodeEditor
    v-model="content"
    @init="editorInit"
    lang="javascript"
    theme="monokai"
    width="100%"
    height="500px"
    :options="{
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      fontSize: 14,
      highlightActiveLine: true,
      enableSnippets: true,
      showLineNumbers: true,
      tabSize: 2,
      showPrintMargin: true,
      showGutter: true,
    }"
    :commands="[
        {
          name: 'save',
          bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
          exec: null,
          readOnly: true,
        },
    ]"
    />
    <!-- /.box -->
    <div class="modal overlay fade in" id="myModal5">
        <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
          <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
            <div class="modal-body" style="padding:0px">
              <div class="row">
                <div class="col-md-12" style="padding:17px">
                  <div class="col-md-12" style="text-align: center;">
                    <p style="font-size: 20px;font-weight: 600;">Window Violated</p><br>
                    <button class="btn btn-success" @click="closeViolated()">Ok</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
      </div>
  </section>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import Vue from 'vue'
import moment from 'moment'
import VueCodeEditor from 'vue2-code-editor'
import $ from 'jquery'
Vue.use(moment)
const optionsOverrides1 = {
  durations: {
    global: 3000
  },
  icons: {
    enabled: false
  },
  labels: {
    success: '',
    warning: '',
    alert: ''
  },
  position: 'bottom-right'
}
export default {
  name: 'addFeedback',
  data () {
    return {
      scheduleDetails: [],
      vOption: [],
      content: '',
      tittle_error: false,
      tittle: '',
      schedule_id: '',
      showmodel: false
    }
  },
  components: {
    VueCodeEditor
  },
  created () {
    this.schedule_id = this.$route.params.id
    this.getscheduleDetails()
    this.content = `
    <!DOCTYPE html>
    <html>
    <body>

    <h1>My First Heading</h1>

    <p>My first paragraph.</p>

    </body>
    </html>`
    $(window).blur(function () {
      $('#myModal5').modal('show')
    })
    $('#myModal5').modal('hide')
  },
  methods: {
    closeViolated () {
      $('#myModal5').modal('hide')
    },
    changeTittle () {
      this.tittle_error = false
    },
    submit () {
      console.log(this.tittle)
      console.log(this.content)
      if (!this.tittle) {
        this.tittle_error = true
        return false
      } else {
        this.tittle_error = false
      }
      if (!this.content) {
        this.$awn.alert('Please write the program', optionsOverrides1)
      }
      const formdata = {
        schedule_id: this.schedule_id,
        title: this.tittle,
        code: this.content
      }
      axios.post(BaseURLV3 + '/interviewer/code', formdata, this.config).then(response => {
        console.log('cee')
        this.$awn.success('Saved successfully')
      }).catch(e => {
      })
    },
    editorInit: function () {
      // vue2-code-editor/node_modules/
      require('brace/ext/language_tools') // language extension prerequsite...
      require('brace/mode/html') // language
      require('brace/mode/javascript')
      require('brace/mode/less')
      require('brace/theme/monokai')
      require('brace/snippets/javascript') // snippet
    },
    play (e) {
      console.log(e)
      console.log(this.checkvideo)
      if (this.checkvideo === 'no' && this.profiledetails.isclient === 'yes') {
        $('video').trigger('pause')
        this.$emit('input', !this.shwovalue)
        this.subscribepopup1()
      } else if (this.checkvideo === 'no' && this.profiledetails.isclient === 'no') {
        $('video').trigger('pause')
        this.$emit('input', !this.shwovalue)
        this.subscribepopup()
      }
    },
    pause (e) {
      console.log(e)
      return false
    },
    getscheduleDetails () {
      console.log(this.$route.params.id)
      $('#myModal5').modal('hide')
      axios.get(BaseURLV3 + '/interviewer/' + this.$route.params.id + '/meeting', this.config).then(response => {
        // this.scheduleDetails = response.data.scheduleList_self[0]
        this.scheduleDetails = response.data.schedule
        // this.vOption = {
        //   type: 'application/x-mpegURL',
        //   src: this.scheduleDetails.interviewer_video,
        //   preload: true,
        //   autoplay: false,
        //   isLoop: false,
        //   controls: 'progress,current,durration,volume',
        //   crossOrigin: false
        // }
      }).catch(e => {
      })
    }
  }
}
</script>
